export const formatSavedTime = (minutes: number): string => {
  if (!Number.isFinite(minutes) || minutes <= 0) return '0 min'

  if (minutes < 60) {
    const roundedMinutes = minutes < 10 ? Number(minutes.toFixed(1)) : Math.round(minutes)
    return `${roundedMinutes} min`
  }

  const totalMinutes = Math.round(minutes)
  const hours = Math.floor(totalMinutes / 60)
  const remainingMinutes = totalMinutes % 60

  if (remainingMinutes === 0) {
    return `${hours} h`
  }

  return `${hours} h ${remainingMinutes} min`
}
